import React from 'react'
import styles from './style.module.scss'

const Footer = () => (
  <div className={styles.footer} />
)

export default Footer
